<script>
  import Page from '@components/page'
  import Form from '@components/forms'
  import ProgrammeFormFields from '@components/programmes/form-fields.svelte'
  import Button from '@components/buttons/button.svelte'
  import { useForm, router } from '@inertiajs/svelte'
  import { Save, BookOpen, ChevronLeft } from 'lucide-svelte'

  const form = useForm({
    name: '',
    key: '',
    starts_on: '',
    ends_on: '',
    description: '',
  })

  function handleSubmit(e) {
    e.preventDefault()
    $form.transform(data => ({ programme: data }))
    $form.post('/admin/programmes', {
      onSuccess: () => router.visit('/admin/programmes'),
    })
  }

  let navigationProps = {
    title: "New programme",
    Icon: BookOpen,
    links: [{ text: "Admin", href: "/admin" }, { text: "Programmes", href: "/admin/programmes" }],
  }
</script>

<Page.Layout title="New programme">

  <Page.Navigation {...navigationProps} />

  <Page.Titles title="New programme" subtitle="Create a new programme">
    {#snippet buttons()}
      <Button text="Back" path="/admin/programmes" BeforeIcon={ChevronLeft} />
      <Button type="submit" form="programme-form" text="Create programme" variant="submit" Icon={Save} loading={$form.processing} />
    {/snippet}
  </Page.Titles>

  <Form.Element {form} id="programme-form" onsubmit={handleSubmit}>
    <ProgrammeFormFields {form} />
  </Form.Element>

</Page.Layout>
